import { resolveSearchBucket } from './adminAnalyticsUtils';

/** Format ISO timestamp for operator display (local timezone). */
export function formatSearchTimestamp(ts) {
  if (!ts) return '—';
  try {
    const d = new Date(ts);
    if (Number.isNaN(d.getTime())) return String(ts);
    return d.toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'medium',
    });
  } catch {
    return String(ts);
  }
}

/** Resolve anonymized client correlation id (new + legacy payloads). */
export function resolveClientHash(search) {
  const hash = search?.remote_addr_hash || search?.remote_addr;
  return hash ? String(hash) : '—';
}

/**
 * Transport badge metadata for admin search detail drawer.
 * @returns {{ kind: string, label: string, eventCount?: number|null }}
 */
export function getSearchTransportInfo(search) {
  const meta = search?.response_meta || {};
  const result = search?.result_json || {};
  const bucket = resolveSearchBucket(search);
  const path = String(search?.path || '');
  const isAi = bucket === 'ai_preprocess' || path.includes('/search/preprocess');
  const isSse = meta.is_sse === true || result.transport === 'sse';

  if (isSse) {
    const eventCount = Number.isFinite(Number(result.event_count)) ? Number(result.event_count) : null;
    return { kind: 'sse', label: 'Server-Sent Events', eventCount };
  }
  if (isAi) {
    return { kind: 'ai_json', label: 'JSON Response (Ollama/spaCy Analysis)' };
  }
  if (result.transport === 'json' || String(meta.mimetype || '').toLowerCase().includes('json')) {
    return { kind: 'json', label: 'JSON Response' };
  }
  return { kind: 'pending', label: result.status || 'Pending' };
}
